// extracted by mini-css-extract-plugin
export default {"wrapper":"MobileMenuComponent_wrapper__e2i3T","container":"MobileMenuComponent_container__iTilG"};